export const ui = {
  TERMS_AND_CONDITIONS_LINK:
    'https://dye1vg6h1p5m0.cloudfront.net/Kaboodle/terms/terms_and_conditions.pdf',
  PRIVACY_POLICY_LINK: 'https://kaboodle.co.uk/privacy',
  WEGLOT_API_KEY: 'wg_5d12d45a25ff7c76d7cd946f5c7ca2b60',
};
